import { motion } from "framer-motion";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import appraisal from "../../Assests/Appraisal.svg";
import band from "../../Assests/Band.svg";
import documentimg from "../../Assests/Documents.svg";
import wtemplate from "../../Assests/Formtemplate.svg";
import hrapprisal from "../../Assests/HRappraisal.svg";
import hrband from "../../Assests/HRband.svg";
import hrdocuments from "../../Assests/HRdocuments.svg";
import hrforms from "../../Assests/HRforms.svg";
import hrpeople from "../../Assests/HRpeople.svg";
import hrpolicies from "../../Assests/HRpolicies.svg";
import hrrecruitment from "../../Assests/HRrecruitement.svg";
import people from "../../Assests/People..svg";
import policies from "../../Assests/Policies.svg";
import recruitment from "../../Assests/Recruitment.svg";
import wpeople from "../../Assests/WPeople.svg";
import wappraisal from "../../Assests/Wappraisal.svg";
import wdocument from "../../Assests/Wdocuments.svg";
import wpolicies from "../../Assests/Wpolicies.svg";
import wrecruiment from "../../Assests/Wrecruitment.svg";
import gband from "../../Assests/gband.svg";
import template from "../../Assests/gformtemplate.svg";
import { HRWrap } from "./style";
import { Card } from "antd";
import Knowmore from "./Knowmore";
import { useNavigate } from "react-router-dom";
import FrameImage1 from "../../Assests/ForesytsPayDark.svg";
import FrameImage2 from "../../Assests/Frame 2147227235.svg";
import FrameImage3 from "../../Assests/Payroll image 3 (1).svg";
import signalicon from "../../../src/Assests/trackright/signalicon.svg";
import Vector from "../../../src/Assests/trackright/Vector.svg";
import Hoverarrowicon from "../../../src/Assests/Hoverarrowicon.svg";
import kpiandalerts from "../../../src/Assests/kpiandalerts.svg";
import kpialertstwo from "../../../src/Assests/kpialertstwo.svg";
import kpialertsthree from "../../../src/Assests/kpialertsthree.svg";
import sparkletwo from "../../../src/Assests/sparkle (2).svg";

import routing from "../../../src/Assests/trackright/routing.svg";
import roundsecurity from "../../../src/Assests/trackright/roundsecurity.svg";
import leaf from "../../../src/Assests/trackright/leaf.svg";
import fuelpump from "../../../src/Assests/trackright/fuelpump.svg";
import ellipseRound from "../../../src/Assests/trackright/ellipseRound.svg";
import Car from "../../../src/Assests/trackright/car.svg";
// import alert from "../../../src/Assests/trackright/alert.svg";
import TrackrightLogo from "../../../src/Assests/trackright/TrackrightLogo.svg";
import vectorOne from "../../../src/Assests/trackright/vectorOne.svg";
import livetrackin from "../../../src/Assests/trackright/livetrackin.svg";
import Frameicon from "../../../src/Assests/trackright/frameIcon.svg";
import intellegentpath from "../../../src/Assests/trackright/intellegentpath.svg";
import sos from "../../../src/Assests/trackright/sos.svg";
import kpialerts from "../../../src/Assests/trackright/kpialerts.svg";
import fleet from "../../../src/Assests/trackright/fleet.svg";
import fleetcontainer from "../../../src/Assests/trackright/fleetcontainer.svg";
import SignalIcon from "../../../src/Assests/signalicon.svg";
import vectorwhite from "../../../src/Assests/vectorwhite.svg";
import vectorne from "../../../src/Assests/Vector 1.svg";
import anchorIcon from "../../../src/Assests/anchorIcon.svg";
import mapimage from "../../../src/Assests/mapimage.svg";
import roundsecurit from "../../../src/Assests/roundsecurity.svg";
import sosimage from "../../../src/Assests/sosimage.svg";
import leafvector from "../../../src/Assests/leafvector.svg";
import releaf from "../../../src/Assests/releaf.svg";
import mdifuelpump from "../../../src/Assests/mdifuelpump.svg";
import carbonfootprint from "../../../src/Assests/carbonfootprint.svg";
import fuelconsumption from "../../../src/Assests/fuelconsumption.svg";
import carfleet from "../../../src/Assests/carfleet.svg";
import routredeviation from "../../../src/Assests/Frame 2147225016.svg";
import carhoverflwwt from "../../../src/Assests/carhoverflwwt.svg";

// import { ReactComponent as SignalIcon } from "../../../src/Assests/signalicon.svg";

import styled from "styled-components";
const StyledWrap = styled.div`
background-color: #f4f4f4;
  .container_hellow {
  }
  .card_background {
    width: 100%;
    /* background-color: #1f243b; */
    border-radius: 8px;
  }
  .frame-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .customized_container {
    width: 450px;
  }
  .container_two {
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .color5 {
    padding: 3px 3px 3px 9px;
  }
  .icon {
    color: #636980;
    transition: color 0.3s ease;
  }

  .menu-item:hover .icon {
    color: white;
  }
`;

const menusOne = [];

const menus = [
  {
    menu: "Real Time Tracking",
    title: "Real Time GPS Visibility",
    description: `We provide you a centralized database where you can store all employee information securely. From basic contact details to employment history, qualifications, and performance evaluations, everything you need to know about your team members is easily accessible in one place. Our intuitive interface makes it simple to keep all employee records organized and up-to-date.`,
    image: livetrackin,
    activeicon: Vector,
    inactiveicon: Hoverarrowicon,
  },
  {
    menu: "Reports & Analytics",
    title: "Data Driven Insights",
    description:
      "Transform raw data into actionable insights. Generate automated daily, weekly, or monthly reports",
    image: vectorne,
    activeicon: vectorwhite,
    inactiveicon: SignalIcon,
  },
  {
    menu: "Fuel Management",
    title: "Fuel Consumption Management",
    description:
      "Take the lead in ESG compliance. Automatically calculate your fleet’s CO2 emissions and identify opportunities to transition to a greener, more sustainable operation.",
    image: fuelconsumption,
    activeicon: mdifuelpump,
    inactiveicon: fuelpump,
  },
  {
    menu: "Automated Routing",
    title: "Intelligent path Optimazation",
    description:
      "Reduce mileage and idling time. Our intelligent algorithms calculate the most efficient paths and routes for you.",
    image: (
      <div
        style={{
          display: "flex",
          flexDirection: "",
          gap: "09px",
          width: "80%",
        }}
      >
        <img src={mapimage} alt="KPIs and Alerts" width="100%" />
        <img
          src={sparkletwo}
          alt="KPIs and Alerts"
          style={{ marginTop: "-100px" }}
          width="20%"
        />
      </div>
    ),

    activeicon: anchorIcon,
    inactiveicon: routing,
  },

  {
    menu: "Carbon Footprint",
    title: "Carbon Footprint",
    description:
      "Take the lead in ESG compliance. Automatically calculate your fleet’s CO2 emissions and identify opportunities to transition to a greener, more sustainable operation.",
    image: carbonfootprint,
    activeicon: leafvector,
    inactiveicon: releaf,
  },
  {
    menu: "Tamper Protection",
    title: "Anti Tamper Technology",
    description:
      "Protect your investment with hardware and software safeguards. Get instant alerts if devices are disconnected, power is cut, or GPS signals are jammed.",
    image: (
      <div
        style={{
          display: "flex",
          flexDirection: "",
          alignItems: "center",
          gap: "09px",
          width: "80%",
        }}
      >
        <img src={sosimage} alt="KPIs and Alerts" width="90%" />
      </div>
    ),
    activeicon: roundsecurit,
    inactiveicon: roundsecurity,
  },
  {
    menu: "Kpi and Alerts",
    title: "Automated Kpis and Notification",
    description:
      "Stay ahead of issues with instant SMS or email alerts for speeding, harsh braking, geofence breaches, or upcoming maintenance.",
    image: (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "",
            gap: "10px",
            width: "50%",
          }}
        >
          <img src={kpialertstwo} alt="KPIs and Alerts" width="100%" />
          <img src={kpialertsthree} alt="KPIs and Alerts" width="100%" />
        </div>
      </>
    ),
    activeicon: kpiandalerts,
    inactiveicon: vectorOne,
  },

  {
    menu: "Fleet utilization",
    title: "Assest effiencey anaysis",
    description:
      "Stop guessing which assets are working hardest. Analyze engine hours, distance traveled, and downtime to optimize your fleet size and ROI.",
    image: fuelconsumption,
    activeicon: carfleet,
    inactiveicon: carhoverflwwt,
  },

  // {
  //   menu: "Real Time Tracking",
  //   title: "Real Time Tracking",
  //   description: `We provide you a centralized database where you can store all employee information securely. From basic contact details to employment history, qualifications, and performance evaluations, everything you need to know about your team members is easily accessible in one place. Our intuitive interface makes it simple to keep all employee records organized and up-to-date.`,
  //   image: livetrackin,
  //   activeicon: livetrackin,
  //   inactiveicon: livetrackin,
  // },
];

const HRManagementComponent = ({
  isHRManagementVisible,
  setScrollItem,
  setColor,
}) => {
  const [selectedMenuIndex, setSelectedMenuIndex] = useState(0);
  const [selectedMenu, setSelectedMenu] = useState(
    menus[selectedMenuIndex] || {},
  );
  const navigate = useNavigate();
  useEffect(() => {
    setSelectedMenu(menus[selectedMenuIndex] || {});
  }, [selectedMenuIndex]);

  // const handleScroll =debounce( () => {
  //   const nextIndex = Math.min(selectedMenuIndex + 1, menus.length - 1);
  //   setSelectedMenuIndex(nextIndex);
  // }, 300);

  // useEffect(() => {
  //   if (isHRManagementVisible) {
  //     setScrollItem("Features")
  //     const handleScrollEvent = (event) => {
  //       if (menus[selectedMenuIndex].menu === "Band") {
  //         handleScroll();
  //       } else {
  //         event.preventDefault();
  //         handleScroll();
  //       }

  //     };

  //     window.addEventListener("wheel", handleScrollEvent, { passive: false });

  //     return () => {
  //       window.removeEventListener("wheel", handleScrollEvent);
  //     };
  //   }
  // }, [selectedMenuIndex, isHRManagementVisible]);

  // useEffect(() => {
  //   document.addEventListener('keydown', handleKeyDown);
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, [selectedMenuIndex, isHRManagementVisible]);
  // const handleKeyDown = (event) => {
  //    if (event.key === 'ArrowDown') {
  //     handleScroll();
  //   }
  // };

  return (
    <>
      <StyledWrap>
        <HRWrap>
          <Row className="container_two">
            <Col lg={2}></Col>
            <Col lg={3}>
              <Container
                style={{ marginTop: "60px" }}
                id="real_time_tracking"
                className="ms-4 pt-2"
              >
                {menus.map((menu, index) => (
                  <div
                    key={index}
                    className={`menu-item cursor-pointer py-3 rounded-lg d-flex px-4 justify-content-start align-items-center text3 color2 ${
                      selectedMenuIndex === index ? "active" : ""
                    }`}
                    onClick={() => setSelectedMenuIndex(index)}
                    style={{
                      fontSize: selectedMenuIndex === index ? "16px" : "15px",
                    }}
                  >
                    <img
                      style={{ width: "22px", height: "22px" }}
                      src={
                        selectedMenuIndex === index
                          ? menu.activeicon
                          : menu.inactiveicon
                      }
                      alt="image"
                      className="pe-1"
                    />
                    {menu.menu}
                  </div>
                ))}
              </Container>
            </Col>
            <Col lg={7}>
              <h3
                style={{ color: "green", paddingBottom: "17px" }}
                className=" color5 text1"
              >
                Features{" "}
              </h3>
              <Container>
                <motion.h3
                  style={{ color: "green", paddingTop: "17px" }}
                  className="py-3 color3 text2"
                >
                  {selectedMenu.title}
                </motion.h3>
                <motion.p
                  style={{
                    width: "60%",
                    marginTop: "10px",
                  }}
                  className="color2 text6"
                >
                  {selectedMenu.description}
                </motion.p>
                {/* <div className="hr-img">
                  <img
                    src={selectedMenu.image}
                    alt="image"
                    width="100%"
                    className="py-2  customized_container"
                  />
                </div> */}
                <div className="hr-img">
                  {typeof selectedMenu.image === "string" ? (
                    <img
                      src={selectedMenu.image}
                      alt="image"
                      width="100%"
                      className="py-2 customized_container"
                    />
                  ) : (
                    <div
                      style={{ width: "45%" }}
                      className="py-2 customized_container"
                    >
                      {selectedMenu.image}
                    </div>
                  )}
                </div>
              </Container>
            </Col>
            <Col>
              <Col lg={12} className="d-flex justify-content-center mt-4">
                <Card className="card_background">
                  <div
                    id="navigatioreference_one"
                    className="frame-container"
                    style={{ marginTop: "", marginBottom: "30px" }}
                  >
                    <img
                      src={fleetcontainer}
                      alt="Frame"
                      className="frame1-image"
                    />
                  </div>
                  {/* <div className="frame-container">
                      <img
                        src={FrameImage2}
                        alt="Frame"
                        className="frame2-image"
                      />
                    </div>
                    <div
                      className="frame-container"
                      onClick={() => {
                        setColor(false);
                        window.scrollTo({ top: 0, behavior: "smooth" });

                        setTimeout(() => {
                          navigate("/Knowmore");
                        }, 300);
                      }}
                    >
                      <button
                        style={{
                          backgroundColor: "#2D53DA",
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#FFFFFF",
                          marginTop: "20px",
                          padding: "5px",
                          width: "158px",
                          height: "40px",
                          borderRadius: "10px",
                        }}
                      >
                        Know More
                      </button>
                    </div>
                    <div
                      className="frame-container"
                      style={{ marginTop: "90px" }}
                    >
                      <img
                        src={FrameImage3}
                        alt="Frame"
                        className="frame3-image"
                      />
                    </div> */}
                </Card>
              </Col>
            </Col>
          </Row>
          {/* <Container className="py-5 my-4 management d-none d-lg-block"></Container> */}
        </HRWrap>
      </StyledWrap>
    </>
  );
};

export default HRManagementComponent;
